import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet } from 'z3k-parser/lib/flags';
export var PumpState;
(function (PumpState) {
    PumpState[PumpState["OFF"] = 0] = "OFF";
    PumpState[PumpState["ON"] = 1] = "ON";
})(PumpState || (PumpState = {}));
export var Pump;
(function (Pump) {
    let Mode;
    (function (Mode) {
        Mode[Mode["ALWAYS_WORK"] = 0] = "ALWAYS_WORK";
        Mode[Mode["BY_HEAT_REQUEST"] = 1] = "BY_HEAT_REQUEST";
    })(Mode = Pump.Mode || (Pump.Mode = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["SUMMER_ROTATION_FLAG"] = 4] = "SUMMER_ROTATION_FLAG";
        Flags[Flags["IS_INVERSE_MODE_FLAG"] = 8] = "IS_INVERSE_MODE_FLAG";
    })(Flags = Pump.Flags || (Pump.Flags = {}));
    Pump.get = createAccessors(arrayGetSet('pumps'), {
        name: 'Насос',
        physical_output: -1,
        delay: 0,
        setting_register: 0,
        pressure_sensor: null,
        pressure_threshold: 0,
    });
    function getMode(pump) {
        return pump?.setting_register & 3;
    }
    Pump.getMode = getMode;
    function setMode(pump, mode) {
        return {
            ...pump,
            setting_register: (pump.setting_register & ~0x3) | mode,
        };
    }
    Pump.setMode = setMode;
    function isInverse(pump) {
        if (!pump?.setting_register)
            return false;
        return isFlagSet(pump, Flags.IS_INVERSE_MODE_FLAG);
    }
    Pump.isInverse = isInverse;
})(Pump || (Pump = {}));
